/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

export const useOnMount = (fn: () => void): void => {
  useEffect(fn, []);
};
